import { render, staticRenderFns } from "./DETicketsProfile.vue?vue&type=template&id=2bea447b&scoped=true"
import script from "./DETicketsProfile.vue?vue&type=script&lang=js"
export * from "./DETicketsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea447b",
  null
  
)

export default component.exports